"use strict";

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SchedulerImplem = void 0;

var TextEscaper_1 = require("../helpers/TextEscaper");

var symbols_1 = require("../../../check/symbols");

var stringify_1 = require("../../../utils/stringify");

var SchedulerImplem = /*#__PURE__*/function (_symbols_1$cloneMetho) {
  function SchedulerImplem(act, taskSelector) {
    _classCallCheck(this, SchedulerImplem);

    this.act = act;
    this.taskSelector = taskSelector;
    this.lastTaskId = 0;
    this.sourceTaskSelector = taskSelector.clone();
    this.scheduledTasks = [];
    this.triggeredTasks = [];
  }

  _createClass(SchedulerImplem, [{
    key: "log",
    value: function log(schedulingType, taskId, label, metadata, status, data) {
      this.triggeredTasks.push({
        status: status,
        schedulingType: schedulingType,
        taskId: taskId,
        label: label,
        metadata: metadata,
        outputValue: data !== undefined ? (0, stringify_1.stringify)(data) : undefined
      });
    }
  }, {
    key: "scheduleInternal",
    value: function scheduleInternal(schedulingType, label, task, metadata, thenTaskToBeAwaited) {
      var _this = this;

      var trigger = null;
      var taskId = ++this.lastTaskId;
      var scheduledPromise = new Promise(function (resolve, reject) {
        trigger = function trigger() {
          (thenTaskToBeAwaited ? task.then(function () {
            return thenTaskToBeAwaited();
          }) : task).then(function (data) {
            _this.log(schedulingType, taskId, label, metadata, 'resolved', data);

            return resolve(data);
          }, function (err) {
            _this.log(schedulingType, taskId, label, metadata, 'rejected', err);

            return reject(err);
          });
        };
      });
      this.scheduledTasks.push({
        original: task,
        scheduled: scheduledPromise,
        trigger: trigger,
        schedulingType: schedulingType,
        taskId: taskId,
        label: label,
        metadata: metadata
      });
      return scheduledPromise;
    }
  }, {
    key: "schedule",
    value: function schedule(task, label, metadata) {
      return this.scheduleInternal('promise', label || '', task, metadata);
    }
  }, {
    key: "scheduleFunction",
    value: function scheduleFunction(asyncFunction) {
      var _this2 = this;

      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _this2.scheduleInternal('function', "".concat(asyncFunction.name, "(").concat(args.map(stringify_1.stringify).join(','), ")"), asyncFunction.apply(void 0, args), undefined);
      };
    }
  }, {
    key: "scheduleSequence",
    value: function scheduleSequence(sequenceBuilders) {
      var _this3 = this;

      var status = {
        done: false,
        faulty: false
      };
      var dummyResolvedPromise = {
        then: function then(f) {
          return f();
        }
      };

      var resolveSequenceTask = function resolveSequenceTask() {};

      var sequenceTask = new Promise(function (resolve) {
        return resolveSequenceTask = resolve;
      });
      sequenceBuilders.reduce(function (previouslyScheduled, item) {
        var _ref = typeof item === 'function' ? [item, item.name, undefined] : [item.builder, item.label, item.metadata],
            _ref2 = _slicedToArray(_ref, 3),
            builder = _ref2[0],
            label = _ref2[1],
            metadata = _ref2[2];

        return previouslyScheduled.then(function () {
          var scheduled = _this3.scheduleInternal('sequence', label, dummyResolvedPromise, metadata, function () {
            return builder();
          });

          scheduled.catch(function () {
            status.faulty = true;
            resolveSequenceTask();
          });
          return scheduled;
        });
      }, dummyResolvedPromise).then(function () {
        status.done = true;
        resolveSequenceTask();
      }, function () {});
      return Object.assign(status, {
        task: Promise.resolve(sequenceTask).then(function () {
          return {
            done: status.done,
            faulty: status.faulty
          };
        })
      });
    }
  }, {
    key: "count",
    value: function count() {
      return this.scheduledTasks.length;
    }
  }, {
    key: "internalWaitOne",
    value: function () {
      var _internalWaitOne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var taskIndex, _this$scheduledTasks$, _this$scheduledTasks$2, scheduledTask;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.scheduledTasks.length === 0)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('No task scheduled');

              case 2:
                taskIndex = this.taskSelector.nextTaskIndex(this.scheduledTasks);
                _this$scheduledTasks$ = this.scheduledTasks.splice(taskIndex, 1), _this$scheduledTasks$2 = _slicedToArray(_this$scheduledTasks$, 1), scheduledTask = _this$scheduledTasks$2[0];
                scheduledTask.trigger();
                _context.prev = 5;
                _context.next = 8;
                return scheduledTask.scheduled;

              case 8:
                _context.next = 12;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](5);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 10]]);
      }));

      function internalWaitOne() {
        return _internalWaitOne.apply(this, arguments);
      }

      return internalWaitOne;
    }()
  }, {
    key: "waitOne",
    value: function () {
      var _waitOne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.act( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this4.internalWaitOne();

                        case 2:
                          return _context2.abrupt("return", _context2.sent);

                        case 3:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function waitOne() {
        return _waitOne.apply(this, arguments);
      }

      return waitOne;
    }()
  }, {
    key: "waitAll",
    value: function () {
      var _waitAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.scheduledTasks.length > 0)) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 3;
                return this.waitOne();

              case 3:
                _context4.next = 0;
                break;

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function waitAll() {
        return _waitAll.apply(this, arguments);
      }

      return waitAll;
    }()
  }, {
    key: "report",
    value: function report() {
      return [].concat(_toConsumableArray(this.triggeredTasks), _toConsumableArray(this.scheduledTasks.map(function (t) {
        return {
          status: 'pending',
          schedulingType: t.schedulingType,
          taskId: t.taskId,
          label: t.label,
          metadata: t.metadata
        };
      })));
    }
  }, {
    key: "toString",
    value: function toString() {
      return 'schedulerFor()`\n' + this.report().map(SchedulerImplem.buildLog).map(function (log) {
        return "-> ".concat(log);
      }).join('\n') + '`';
    }
  }, {
    key: _symbols_1$cloneMetho,
    value: function value() {
      return new SchedulerImplem(this.act, this.sourceTaskSelector);
    }
  }], [{
    key: "buildLog",
    value: function buildLog(reportItem) {
      return "[task${".concat(reportItem.taskId, "}] ").concat(reportItem.label.length !== 0 ? "".concat(reportItem.schedulingType, "::").concat(reportItem.label) : reportItem.schedulingType, " ").concat(reportItem.status).concat(reportItem.outputValue !== undefined ? " with value ".concat((0, TextEscaper_1.escapeForTemplateString)(reportItem.outputValue)) : '');
    }
  }]);

  return SchedulerImplem;
}(symbols_1.cloneMethod);

exports.SchedulerImplem = SchedulerImplem;